import React, { ChangeEvent, useState } from 'react'
import { FormField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { ClientPlatformLimitDto } from 'api/Clients/Types/ClientDetailedDto'
import { PlatformTypeName } from 'api/Trading-Accounts/Types/PlatformTypeDto'
import { NonNegativeIntegerPattern } from 'utils/formValidation'

interface Props {
  isOpen?: boolean
  onClose(): void
  modalData: ClientPlatformLimitDto
  saveModalForm(data: ClientPlatformLimitDto): void
}

export const ClientDetailsDashboardEditPlatformLimits: React.FC<Props> = ({
  isOpen,
  onClose,
  modalData,
  saveModalForm,
}) => {
  const [data, setData] = useState<ClientPlatformLimitDto>(modalData)

  const maxTradingAccountLimit = 2000000

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>, fieldName: string) => {
    const { value } = event.target
    if (NonNegativeIntegerPattern.test(value)) {
      const numericValue = Number(value)
      const newValue = numericValue > maxTradingAccountLimit ? maxTradingAccountLimit : numericValue
      setData({ ...data, [fieldName]: newValue.toString() })
    }
  }

  const handleSave = () => {
    saveModalForm(data)
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{`Platform Limits - ${PlatformTypeName[modalData.platformTypeId]}`}</DialogTitle>
        </DialogHeader>
        <div className='flex flex-col gap-4'>
          <FormField
            label='Live'
            type='number'
            value={data.liveTradingAccountLimit}
            onClick={(event) => event.currentTarget.select()}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              handleOnChange(event, 'liveTradingAccountLimit')
            }
          />
          <FormField
            label='Demo'
            type='number'
            value={data.demoTradingAccountLimit}
            onClick={(event) => event.currentTarget.select()}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              handleOnChange(event, 'demoTradingAccountLimit')
            }
          />
        </div>
        <DialogFooter>
          <Button onClick={onClose} type='button' variant='outline'>
            Cancel
          </Button>
          <Button onClick={handleSave} type='button'>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
